export default function sanityToPath(type: string, slug: string): string {
	switch (type) {
		case 'work':
			return '/works/' + slug;
		case 'event':
			return '/events/' + slug;
		case 'post':
			return '/writing/' + slug;

		default:
			return '/';
	}
}

export function sanityTypeName(type: string): string {
	switch (type) {
		case 'work':
			return 'Works';
		case 'event':
			return 'Events';
		case 'post':
			return 'Writing';

		default:
			return '';
	}
}
